module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "copy"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_vm._v("© 1999 by Sharon Linnéa Scott")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 1999 by")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Eerdmans Books for Young Readers")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("an imprint of")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Wm. B. Eerdmans Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("P.O. Box 163, Cambridge CB3 9PU U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("February 2010, seventh printing")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Linnéa, Sharon.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Princess Ka‘iulani: hope of a nation, heart of a people / by Sharon Linnéa.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Includes "), _c('a', {
    attrs: {
      "href": "#/eerkaiulani0039#bib"
    }
  }, [_vm._v("bibliographical references")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/eerkaiulani0042#ind"
    }
  }, [_vm._v("index")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 978-0-8028-5088-1 (pbk.: alk. paper); 978-1-4674-3200-9 (ePub)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("1. Kaiulani, Princess of Hawaii, 1875–1899 — Juvenile literature.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("2. Princesses — Biography — Juvenile literature.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("3. Hawaii — History — Juvenile literature. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("DU627.17.K3L56 1999")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("996.9′ 02′ 092 — dc21")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("[B] 97-14260")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("CIP")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com/youngreaders",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com/youngreaders")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10dbd104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-kaiulani-0005.vue
// module id = 66
// module chunks = 0